import React, { Fragment, useEffect } from 'react';
import { pick, isEmpty, } from 'lodash';
import qs from 'qs';
import { useLocalStorage } from 'react-use';

import env from '../../env';
import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useQueryParams from '../hooks/useQueryParams';
import ModelFormModal from '../modals/ModelFormModal';
import HeaderNav from '../HeaderNav';
import SideNav from '../SideNav';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');

export default function PageHOC(WrappedComponent) {
  return function Page (props) {
    const { user, isOldAppVersion, } = props;
    const queryParams = useQueryParams();
    const { token, } = queryParams;
    const tenant = useDocumentSubscription(user.tenantId && tenantsRef.doc(user.tenantId), [user]);
    const amazonMwsSettings = useDocumentSubscription(tenant?.ref.collection('tenantSettings').doc('amazonMws'), [tenant?.id]);
    useEffect(() => {
      if(tenant && !tenant.amacodeToken && token) {
        tenant.ref.update({ amacodeToken: token, amacodeIntegratedAt: new Date(), });
      }
    }, [tenant, token]);
    useEffect(() => {
      if(tenant != null && !tenant.tenantOptionValues?.includes('multiSellers') && queryParams.amazon_callback_uri) {
        (async () => {
          await tenant.ref.update({ spId: queryParams.selling_partner_id, });
          window.location.href = queryParams.amazon_callback_uri + '?' + qs.stringify({ redirect_uri: env('SP_API_AUTH_REDIRECT_URI'), amazon_state: queryParams.amazon_state, version: queryParams.version, });
        })();
      }
    }, [tenant]);
    useEffect(() => {
      (async () => {
        if (tenant != null && !tenant.tenantOptionValues?.includes('multiSellers') && ['accessToken', 'refreshToken', 'expires'].every(_ => queryParams[_])) {
          await tenant.ref.update({ spApi: pick(queryParams, ['accessToken', 'refreshToken', 'expires']) });
          window.location.href = '/';
          return;
        }
      })();
      (async () => {
        if (tenant != null && queryParams.shopify != null) {
          await tenant.ref.update({ shopify: queryParams.shopify });
          window.location.href = '/';
          return;
        }
      })();
    }, [queryParams.shopify != null, tenant != null]);

    return tenant != null && (
      <div className="page h-100">
        <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
          <HeaderNav {...{ ...props, tenant }} />
          <div className="d-flex flex-fill">
            <SideNav {...{ ...props, tenant }} style={{ top: isOldAppVersion ? 81 : 51, width: 200, minWidth: 200, }} />
            <div className="flex-fill d-flex" style={{ marginLeft: 200, marginTop: 51, }}>
              <div className="w-100">
                {
                  amazonMwsSettings?.sellerId != null && tenant?.spApi == null && (
                    <div className="alert alert-danger py-2">
                      2022年9月27日（火）付でAmazon MWS APIが廃止されます。<br />
                      上記期日までに<a href="https://www.notion.so/wizzlinx/Amazon-SP-API-d304e5bb363c4850b5b88dc0414f6fc8" target="_blank">こちら</a>のガイドに沿って必ずSP API認証を行なってください。（所要時間1分）
                    </div>
                  )
                }
                <WrappedComponent {...{ ...props, tenant }} />
              </div>
            </div>
          </div>
        </div>
        {
          tenant.tenantOptionValues?.includes('multiSellers') && (
            <MultiSellersConent tenant={tenant} />
          )
        }
      </div>
    );
  };
};

function MultiSellersConent(props) {
  const { tenant } = props;
  const queryParams = useQueryParams();
  const [localSelectedExtraSellerId, setLocalSelectedExtraSellerId] = useLocalStorage('selectedExtraSellerId');
  const extraSellers = useCollectionSubscription(tenant.ref.collection('extraSellers').orderBy('createdAt'), [tenant]);
  const extraSellerOptions = [{ ...tenant, name: 'メイン' }, ...extraSellers].map(_ => ({ value: _.id, label: _.name, data: _, }));
  const fields = {
    extraSellerId: {
      type: 'select',
      options: extraSellerOptions,
      validations: {
        required: v => !isEmpty(v),
      },
    },
  };
  const onSubmitFlow1 = async ({ extraSellerId }) => {
    const target = extraSellerOptions.find(_ => _.value === extraSellerId).data;
    await target.ref.update({ spId: queryParams.selling_partner_id, });
    setLocalSelectedExtraSellerId(extraSellerId);
    window.location.href = queryParams.amazon_callback_uri + '?' + qs.stringify({ redirect_uri: env('SP_API_AUTH_REDIRECT_URI'), amazon_state: queryParams.amazon_state, version: queryParams.version, });
  };
  const onSubmitFlow2 = async ({ extraSellerId }) => {
    const target = extraSellerOptions.find(_ => _.value === extraSellerId).data;
    await target.ref.update({ spApi: pick(queryParams, ['accessToken', 'refreshToken', 'expires']) });
    window.location.href = '/';
  };
  useEffect(() => {
    if(['accessToken', 'refreshToken', 'expires'].every(_ => queryParams[_]) && localSelectedExtraSellerId) {
      console.log(localSelectedExtraSellerId);
      (async () => {
        const target = extraSellerOptions.find(_ => _.value === localSelectedExtraSellerId)?.data;
        if(target == null) return;

        await target.ref.update({ spApi: pick(queryParams, ['accessToken', 'refreshToken', 'expires']) });
        window.location.href = '/';
      })();
    }
  }, [extraSellers]);

  return (
    <Fragment>
      {
        !isEmpty(queryParams.amazon_callback_uri) && (
          <ModelFormModal isOpen title="ショップ選択" fields={fields} submitLabel="次へ" onSubmit={onSubmitFlow1} />
        )
      }
      {
        ['accessToken', 'refreshToken', 'expires'].every(_ => queryParams[_]) && (
          <ModelFormModal isOpen title="ショップ選択" fields={fields} submitLabel="完了" onSubmit={onSubmitFlow2} />
        )
      }
    </Fragment>
  );
}
